import { RuntimeError } from '@belimo-retrofit-portal/logic';
import * as D from 'io-ts/Decoder';
import { SagaIterator } from 'redux-saga';
import { decodeOrThrow } from 'src/io/utils/decodeOrThrow';
import { WORKER_ERROR } from 'src/modules/worker/codecs/WorkerError';
import { doOnWorker } from 'src/modules/worker/sagas/utils/doOnWorker';
import { WorkerResponse } from 'src/modules/worker/types/WorkerResponse';
import { call } from 'typed-redux-saga';

export function createWorkerHandler<Result>(
  workerUrl: string,
  decoder: D.Decoder<unknown, Result>,
): <Request>(request: Request) => SagaIterator<Result> {
  const WORKER_RESULT_FAILURE = D.struct({
    type: D.literal('failure'),
    error: WORKER_ERROR,
  });
  const WORKER_RESULT_SUCCESS = D.struct({
    type: D.literal('success'),
    content: decoder,
  });
  const WORKER_RESULT: D.Decoder<unknown, WorkerResponse<Result>> = D.sum('type')({
    success: WORKER_RESULT_SUCCESS,
    failure: WORKER_RESULT_FAILURE,
  });

  return function* workerHandler(request) {
    const response = yield* call(doOnWorker, workerUrl, request);
    const data = decodeOrThrow(
      WORKER_RESULT,
      response,
    );
    if (data.type === 'failure') {
      throw new RuntimeError(
        `Error while executing "${workerUrl}" worker (${data.error.name}: ${data.error.message})`,
        { error: data.error },
      );
    }

    return data.content;
  };
}
